import { FadeUp } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import RootLine from "@/components/RootLine";

const PorOndeComecarTeaser = () => (
  <section data-testid="por-onde-comecar-teaser" className="relative overflow-hidden py-20 lg:py-28">
    <div className="container-x text-center">
      <FadeUp>
        <p className="eyebrow">07 — Orientação</p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className="mx-auto mt-5 max-w-2xl font-serif text-3xl font-light leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-5xl" data-testid="por-onde-comecar-teaser-title">
          Por onde <em className="italic text-raiz-700">começar?</em>
        </h2>
      </FadeUp>
      <FadeUp delay={0.16}>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-ink/65">
          Entenda as possibilidades e conheça qual serviço pode estar relacionado ao que você procura — por meio de um mapa simples e visual.
        </p>
      </FadeUp>
      <FadeUp delay={0.24} className="mt-9">
        <ArrowButton to="/por-onde-comecar" testId="por-onde-comecar-teaser-cta">
          Ver o mapa de orientação
        </ArrowButton>
      </FadeUp>
    </div>
    <RootLine className="mt-14 h-16 opacity-70 lg:h-20" />
  </section>
);

export default PorOndeComecarTeaser;
